import { DataItem } from '../../../../types/common';
import { TaskActivity } from './activity';
import { TaskBoard } from './board';
import { TaskPriority } from './priority';
import { TaskRelation } from './relation';
import { TaskSwimlane } from './swimlane';

export interface Task {
  id: number;
  summary: string;
  description: string;
  board: TaskBoard;
  swimlane: TaskSwimlane;
  isOverdue: boolean;
  due: {
    datetime: string;
  };
  flag: { active: boolean; reason: string };
  relations: TaskRelation[];
  accounts?: Omit<TaskAccount, 'tasks'>[];
  appointments?: TaskAppointment[];
  activities: TaskActivity[];
  // tasks.get.php sends id, name and order only; showInDropdown belongs to the priorities list
  priority: Omit<TaskPriority, 'showInDropdown'>;
}

// The task view only reads ids (and counts) of related accounts and appointments.
type TaskAccount = Pick<DataItem, 'id'>;

type TaskAppointment = Pick<DataItem, 'id'>;

export const resolutionTypes = {
  'Repair/fix': 'Repair/fix',
  Reimburse: 'Reimburse',
  Refund: 'Refund',
  Replace: 'Replace',
  Denied: 'Denied',
};
